import { downloadFile, exportCsv, onMessageSend, postFiles } from '@/api'
import { DocumentType } from '@/types/file'
import {
  useDownloadCsv,
  useDownloadFile,
  useInvalidateOnSuccessMutation,
} from '@/utils'
import { useMutation } from 'react-query'

export const makeQueryKey = (array: string[], el: string): string[] => {
  return [el, ...array]
}

export const useUploadFiles = (
  id: string,
  entity: string,
  type: DocumentType,
  extraKey: string,
) =>
  useInvalidateOnSuccessMutation(
    makeQueryKey([entity, id], extraKey),
    ({
      files,
      id: entityId,
      category,
    }: {
      files: File[]
      id?: string
      category?: string
    }) => postFiles(entityId || id, files, type, category),
  )

export const useSendMessage = () =>
  useMutation((message: string) => onMessageSend(message))

export const usePreviewFile = () => useDownloadFile(downloadFile)

/**
 * TODO: fix type
 * TODO: this should be a generic function
 */
export const useExportCsv = () =>
  useDownloadCsv(({ companyId, archivedView }: any) =>
    exportCsv(companyId, archivedView),
  )
